import { useFederatedSignin } from '../../app/auth'
import { GoogleButtonComponent, GoogleButtonTextContainer } from './GoogleButtonStyled'

import { Body, Spacer } from '@spritz-finance/ui'
import GoogleLogo from '../../../assets/icons/google.png'

interface GoogleButtonProps {
    label: string
}

export default function GoogleButton({ label }: GoogleButtonProps) {
    const { federatedSignin } = useFederatedSignin()

    return (
        <GoogleButtonComponent onClick={() => federatedSignin()}>
            <GoogleButtonTextContainer>
                <img alt="Google Logo" src={GoogleLogo} />
                <Spacer width={8} />
                <Body.SmBold size={14}>{label}</Body.SmBold>
            </GoogleButtonTextContainer>
        </GoogleButtonComponent>
    )
}
